// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"394":"252ff800","657":"efe2e41c"}[chunkId] + ".chunk.css";
};